export default __webpack_public_path__ + "static/media/ished.c58baa08.png";